import React from 'react';
import styled from 'styled-components';
import { Icon, InfoLabel } from '@cubeyou-team/hx-react-components';

const StyledInfoLabelContainer = styled.div`
  position: absolute;
  top: -24px;
  display: none;
  left: 50%;
  transform: translate(-50%, 0);
  width: max-content;
`;

const StyledButtonToggleView = styled.button`
  position: absolute;
  height: 24px;
  width: 24px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  cursor: pointer;
  z-index: 2;
  right: -12px;

  &:hover {
    ${StyledInfoLabelContainer} {
      display: block;
    }
  }

  &:focus {
    outline: 0;
  }
`;

const RepositoryToggleView = ({ checked, label, style, onClick }) => {
  return (
    <StyledButtonToggleView
      className="bg-hx-secondary hover:bg-hx-secondary-hover"
      style={style}
      onClick={() => onClick(!checked)}
    >
      <Icon
        icon={checked ? 'chevron_left' : 'chevron_right'}
        size="xsmall"
        variant="light"
      />
      <StyledInfoLabelContainer>
        <InfoLabel label={label} />
      </StyledInfoLabelContainer>
    </StyledButtonToggleView>
  );
};

export default RepositoryToggleView;
